import { render } from "./ZoomScreen.vue?vue&type=template&id=4f5410b8&ts=true"
import script from "./ZoomScreen.vue?vue&type=script&lang=ts"
export * from "./ZoomScreen.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__